import strings from 'strings';

export const PERSISTENCE_KEY = 'candidateQuickEntry';
export const COPIES = strings.inventory.quickEntry.table;

export const ORDER_BY_OPTIONS = {
  column: 'createdAt',
  direction: 'desc'
};

export const COLUMNS = [
  {
    name: 'id',
    options: {
      filter: false,
      display: 'excluded'
    }
  },
  {
    name: 'candidateName',
    label: COPIES.columns.name,
    options: {
      sort: true,
      display: true
    }
  },
  {
    name: 'notes',
    label: COPIES.columns.preview,
    options: {
      sort: false,
      display: true,
      renderer: {
        id: 'trimText'
      },
      setCellProps: () => ({
        style: { whiteSpace: 'pre-wrap' }
      })
    }
  },
  {
    name: 'statusTitle',
    label: COPIES.columns.status,
    options: {
      sort: true,
      display: true
    }
  },
  {
    name: 'createdAt',
    label: COPIES.columns.createdOn,
    options: {
      sort: true,
      display: true,
      renderer: 'date'
    }
  }
];
